var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLight7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 10,
    fill: "#EAFCFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1280_130632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7203 11.5996C30.1887 11.5996 23.5227 15.3595 19.4878 21.0972C20.3229 21.6419 21.1369 22.389 21.9241 23.3494C24.9343 18.8485 29.8013 15.6906 35.4326 15.0118L37.72 18.8825L40.0073 15.0117C48.6635 16.0549 55.5441 22.9351 56.5878 31.5913L52.7165 33.8789L56.5879 36.1667C55.8902 41.9539 52.5758 46.9364 47.8737 49.9226C48.1732 50.6053 48.342 51.3034 48.3718 52.0232C48.3938 52.5492 48.3395 53.0462 48.2304 53.518C55.2295 49.7572 60 42.3659 60 33.8793C60 21.594 50.0057 11.5996 37.7203 11.5996ZM43.4058 48.2922C38.2698 44.1645 36.8336 46.1935 34.5032 48.5235C32.8763 50.1511 28.7591 46.7525 25.2041 43.1973C21.6489 39.6417 18.2509 35.5252 19.8777 33.898C22.2083 31.5678 24.2367 30.1308 20.1079 24.9962C15.9804 19.8597 13.2289 23.8031 10.9715 26.0607C8.36529 28.666 10.8342 38.3749 20.4298 47.972C30.0267 57.5677 39.7355 60.035 42.3401 57.4307C44.5973 55.173 48.542 52.4218 43.4058 48.2922ZM27.7636 37.366C27.7636 32.8007 33.1084 31.9874 33.1084 30.2058C33.1084 29.3414 32.4164 28.9784 31.7763 28.9784C30.6001 28.9784 29.9435 30.2924 29.9435 30.2924L27.695 28.7879C27.695 28.7879 28.8366 26.1245 32.0534 26.1245C34.0767 26.1245 36.2732 27.2834 36.2732 29.9121C36.2732 33.769 31.2921 34.5129 31.2055 36.104H36.4637V38.6981H27.9022C27.8155 38.2139 27.7636 37.7818 27.7636 37.366ZM37.7281 33.873L42.5021 26.3317H46.2031V33.1983H47.673V35.7057H46.2031V38.6982H43.2107V35.7057H37.7281V33.873H37.7281ZM43.2106 33.1982V30.431C43.2106 29.7563 43.3145 29.047 43.3145 29.047H43.2799C43.2799 29.047 43.0208 29.8083 42.6745 30.3271L40.8071 33.1637V33.1984L43.2106 33.1982Z",
    fill: "#009999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1280_130632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLight7);
export default __webpack_public_path__ + "static/media/Icon-light-7.cb9aeded2c0c03859dbe7dd6203f4efb.svg";
export { ForwardRef as ReactComponent };